// Map preview image, loaded once it scrolls into view: from the map's own
// files when it is on this device, else from the server.

import { useEffect, useRef, useState } from 'preact/hooks';
import { useApp } from '../context';
import { levelshotUrl } from '../maps/levelshots';
import { mapIndexVersion, net, vfsVersion } from '../state';

export function Levelshot({ map, class: cls, eager = false }: { map: string; class?: string; eager?: boolean }) {
  const app = useApp();
  const ref = useRef<HTMLDivElement>(null);
  const [url, setUrl] = useState<string | null>(null);
  const [inView, setInView] = useState(eager);
  const versions = `${vfsVersion.value}:${mapIndexVersion.value}`;
  const n = net.value;
  const remote = n.client && n.maps.some((m) => m.name === map && m.levelshot) ? `${n.client.httpBase}/levelshot/${encodeURIComponent(map)}` : null;

  useEffect(() => {
    if (inView || !ref.current) return;
    if (typeof IntersectionObserver === 'undefined') return setInView(true);
    const io = new IntersectionObserver((entries) => entries.some((e) => e.isIntersecting) && setInView(true), { rootMargin: '200px' });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [inView]);

  useEffect(() => {
    if (!inView) return;
    let alive = true;
    levelshotUrl(app.vfs, map).then((u) => alive && setUrl(u ?? remote));
    return () => {
      alive = false;
    };
  }, [map, inView, versions, remote]);

  return (
    <div ref={ref} class={`levelshot${url ? ' loaded' : ''}${cls ? ` ${cls}` : ''}`}>
      {url ? <img src={url} alt="" decoding="async" draggable={false} onError={() => setUrl(null)} /> : <span class="levelshot-fallback">{map.slice(0, 2).toUpperCase()}</span>}
    </div>
  );
}
